export default "__VITE_ASSET__BfEk_pb9__"